import {lazy} from "react";
import Error from "@/components/error/error.tsx";
import {Route} from "react-router";

const UserProfile = lazy(
    () => import("@/app/identity-access-management/partner/features/user-profile/user-profile.tsx")
);

const PartnerRoutes= [
    <Route path="auth/user-profile" element={<UserProfile />} errorElement={<Error/>} />,
];
export default PartnerRoutes;
